import { render, staticRenderFns } from "./WechatAuth.vue?vue&type=template&id=7f340189&scoped=true"
import script from "./WechatAuth.vue?vue&type=script&lang=js"
export * from "./WechatAuth.vue?vue&type=script&lang=js"
import style0 from "./WechatAuth.vue?vue&type=style&index=0&id=7f340189&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f340189",
  null
  
)

export default component.exports